/* eslint-disable no-undef */
/* eslint-disable import/prefer-default-export */

/**
 * @param {string} action GTM eventAction
 * @param {string} label GTM eventLabel
 */

export function gtmPush(action, label) {
  window.GTMDataLayer.push({
    event: 'gaEvent',
    eventCategory: 'interactive-war-crimes',
    eventAction: action,
    eventLabel: label,
    eventNI: false,
  });
}
